export default "__VITE_ASSET__B3IVEqCR__"